import { StarFourPointsCircleIcon } from './StarFourPointsCircleIcon';

/**
 * author: Jeff Anders
 * id ABA4EF5C-BB66-4FEA-85A0-74ABAC4B0222
 * name star-four-points-circle
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-four-points-circle.svg
 * tags
 * - Shape 
 */
export const AutoCircleIcon = StarFourPointsCircleIcon;
export default AutoCircleIcon